// First Created - 19 May 2025
// Author - Atul Pandey
// Updated - 20 May 2025 - added 'all' support for merged nudges
// Updated - 23 May 2025 - refined all day nudge actions

export const getNudgeActionMap = (timeSegment) => {
  const maps = {
    early_morning: {
      "Review upcoming meetings": "review_meetings",
      "Clear your action backlog": "review_actions",
      "Reflect on yesterday’s conversations": "reflect_yesterday",
      "Capture fresh thoughts or blog ideas": "write_blog",
    },
    morning: {
      "Review your Mission Performance":"mission_performance", // 25 May 2025
      "Stay energized with morning habits": "morning_habits",
      "Revisit prep for your next meeting": "review_prep",
      // "Set 2–3 priorities for today’s sessions": "set_priorities",
      
    },
    mid_day: {
      "Log conversations from earlier meetings": "log_conversations",
      "Add any follow-up action items": "add_action_items",
      // "Sync thoughts from team/client check-ins": "sync_thoughts",
      "Review your Vision & missions":"setup_vision_and_missions",  // 25 May 2025
    },
    evening: {
      "Review actions completed": "review_completed_actions",
      "Celebrate your wins and contributions": "celebrate_wins",
      "Reflect on what energized you today": "reflect_energy",
    },
    night: {
      "Preview meetings for tomorrow": "preview_meetings",
      "Send gratitude notes to clients or team": "send_gratitude",
      "Capture any lingering challenges or intentions": "log_challenges",
    },
    // all:{
    //   "Reflect on yesterday’s insights":"reflect_yesterday",
    //   "Capture fresh thoughts or blog ideas":"write_blog",
    //   "Stay energized with morning habits":"morning_habits",
    //   "Review upcoming meetings for today":"review_meetings",
    //   "Clear your action backlog":"review_actions",
    //   "Log conversations from earlier meetings":"log_conversations",
    //   "Add any follow-up action items":"add_action_items",
    //   "Set up or refine your vision & missions":"setup_vision_and_missions", // New - 23 May 2025
    //   "Review actions completed": "review_completed_actions",
    //   "Celebrate your wins and contributions": "celebrate_wins",
    //   "Review your Mission Performance": "mission_performance", // New - 23 May 2025
    //   "Preview meetings for tomorrow": "preview_meetings",
    //   "Capture any lingering challenges or intentions":"log_challenges",
    //   "Send gratitude notes to those who made your day!": "send_gratitude",
    // }
  };

  if (timeSegment === "all") {
    // Merge all time segments into one flat map
    return Object.values(maps).reduce((acc, segmentMap) => ({ ...acc, ...segmentMap }), {});
  }

  return maps[timeSegment] || {};
};